import { signIn, getSession } from "next-auth/react"
import { useFormik } from "formik";
import Input from "../../components/form/input";
import Title from "../../components/Title";
import { loginSchema } from "../../components/schema/loginSchema";
import Button_primary from "../../components/items/Button_primary";
import { FaGithub } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import Link from "next/link";
import { useRouter } from "next/router";

export default function Login() {
  const { push } = useRouter();

  const { values, errors, touched, handleSubmit, handleChange, handleBlur } =
    useFormik({
      initialValues: {
        yourMail: '',
        passWd: '',
      },
      onSubmit: async (values) => {
        try {
          signIn('credentials', {
            redirect: false,
            email: values.yourMail,
            password: values.passWd,
          });
          actions.resetForm();
          push("/profile");
        } catch (error) {
          console.log(error);
        }
      },
      validationSchema: loginSchema
    });

  const inputs = [
    {
      id: 1, type: 'text', name: 'yourMail', label: 'Mail'
      , value: values.yourMail
      , errorMessage: errors.yourMail
      , touched: touched.yourMail
    },
    {
      id: 2, type: 'password', name: 'passWd', label: 'Password'
      , value: values.passWd
      , errorMessage: errors.passWd
      , touched: touched.passWd
    },
  ]

  return (
    <div className="container mx-auto">
      <form onSubmit={handleSubmit} className="flex flex-col items-center my-20 md:w-1/2 w-full mx-auto">
        <Title baslik="Login" addClass="font-bold font-dancing text-[40px]" />
        <div className="flex flex-col gap-y-3 mt-8 w-full" >
          {
            inputs.map((input) => (
              <Input key={input.id} {...input}
                onChange={handleChange}
                onBlur={handleBlur}
              />
            ))
          }
          <div className="flex flex-col mt-4 gap-y-2 w-full">
            <Button_primary type="submit" label="Login" />
            <div className="flex flex-row gap-x-2">
              <button type="button" className="bg-secondary px-[1.5rem] py-[0.5rem] text-white rounded-[1.5rem] w-full" onClick={() => signIn("github")}>
                <div className="flex flex-row justify-center items-center mx-auto gap-x-2">
                  <FaGithub />
                  <span>Github</span>
                </div>
              </button>
              <button type="button" className="px-[1.5rem] py-[0.5rem] rounded-[1.5rem] border-2 w-full" onClick={() => signIn("google")}>
                <div className="flex flex-row justify-center items-center mx-auto gap-x-2">
                  <FcGoogle />
                  <span>Google</span>
                </div>
              </button>
            </div>
            <div className="flex justify-between">
              <Link href="/auth/register">
                <span className="text-sm underline cursor-pointer text-gray-600">Create an account</span>
              </Link>
              <Link href="/admin/login">
                <span className="text-sm underline cursor-pointer text-black">Admin</span>
              </Link>
            </div>
          </div>
        </div>
      </form>
    </div>
  )
}

export async function getServerSideProps({ req }) {
  const session = await getSession({ req });

  if (session) {
    return {
      redirect: {
        destination: "/",
      },
    };
  }

  return {
    props: {},
  };
}